/**
 * 通过location 获取 applicationId
 * @returns applicaionId
 */
export const getApplicationIdByReg = () => {
  try {
    const id = location.href.match(/admin\/(\w+?)\//)?.[1];
    return id;
  } catch (error) {
    return null;
  }
};
